import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft } from "react-icons/fa";

import styles from "./OrderDetailsPage.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { route } from "../../static/route";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchOrderDetailsData,
  getOrderDetails,
} from "../../features/orderDetails/orderDetailsSlice";
import { FaFilePdf } from "react-icons/fa6";
import OrderCloseForm from "../../components/orderDetails/OrderCloseForm";
import OrderPdf from "../../components/orderDetails/OrderPdf";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { POST } from "../../services/axios.service";

const OrderDetailsPage = () => {
  const { orderId } = useParams();
  const printRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const order = useAppSelector(getOrderDetails);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleGoToBack = () => {
    navigate(-1);
  };

  const handlePrintReport = async () => {
    setErrorMessage(null);
    try {
      await POST(
        `/v1/worker/${order?.status === 1 ? "payments" : "orders"}-reports`,
        {
          payment_id: order?.payment_id,
          order_ids: [order?.id],
        }
      )
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            setErrorMessage(response.data.message);
          }
        })
        .catch((error: any) => {
          setErrorMessage(error.data.message);
        });
    } catch (error) {
      setErrorMessage("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }
  };

  useEffect(() => {
    if (orderId)
      dispatch(fetchOrderDetailsData({ orderId: parseInt(orderId) }));
  }, [orderId]);

  return (
    <Layout className="print:max-h-[148mm]">
      <div className={styles.OrderDetailsPage}>
        <div className="w-full px-10 h-[200px] text-center flex flex-col justify-center relative">
          <FaArrowLeft
            onClick={handleGoToBack}
            className="absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-4xl mt-6 font-bold text-white">કામ ની વિગત</h1>
        </div>

        <div className="w-full relative mt-[70px] px-10 py-5 lg:mt-[20px]">
          {order ? (
            <div className="w-full p-6 bg-primary-2 bg-opacity-50 rounded-xl shadow mb-5">
              <h5 className="text-primary-1 text-xl font-semibold text-center">
                કામ નું આઇડી : {order?.id || ""}
              </h5>

              <div className="flex flex-col gap-3 mt-6 text-center">
                <p className="text-primary-1 text-sm font-semibold">
                  પાર્ટી :{" "}
                  {order?.party?.firm_name +
                    (order?.party?.name ? " - " + order?.party?.name : "") +
                    (order?.party?.phone
                      ? " (" + order?.party?.phone + ")"
                      : "")}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  આઈટમ : {order?.item?.name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  પ્રોસેસ : {order?.process?.name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  યુનિટ : {order?.unit?.name}
                </p>
                {/* <p className="text-primary-1 text-sm font-semibold">
                  રેટ/ભાવ : {order?.rate}
                </p> */}
                <p className="text-primary-1 text-sm font-semibold">
                  {order.unit_id === 3
                    ? "જોડી"
                    : order.unit_id === 2
                    ? "નંગ"
                    : "વજન"}{" "}
                  : {order.qty}
                </p>
                {order.unit_id > 1 && (
                  <p className="text-primary-1 text-sm font-semibold">
                    વજન : {order.weight}
                  </p>
                )}
                {order?.status === 1 && (
                  <>
                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ{" "}
                      {order.unit_id === 3
                        ? "જોડી"
                        : order.unit_id === 2
                        ? "નંગ"
                        : "વજન"}{" "}
                      {order.delivered_qty}
                    </p>

                    {order.unit_id > 1 && (
                      <p className="text-primary-1 text-sm font-semibold">
                        ડિલિવર કરેલ વજન : {order.delivered_weight}
                      </p>
                    )}

                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ તારીખ :{" "}
                      {moment(
                        order?.delivered_date,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("DD-MM-YYYY hh:mm A")}
                    </p>

                    {/* <p className="text-primary-1 text-sm font-semibold">
                      અમાઉન્ટ : {order?.amount}
                    </p> */}
                  </>
                )}
              </div>

              <div className="w-full flex flex-col">
                <button
                  className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  type="button"
                  onClick={handlePrintReport}
                >
                  <FaFilePdf className="text-white mt-1" />
                  PDF
                </button>
                {errorMessage && (
                  <p className="text-red-500 text-sm font-semibold text-center">
                    {errorMessage}
                  </p>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="mt-4 text-primary-2 font-bold text-2xl">
                કામ ની વિગતો મળી નથી.
              </p>

              <div className="w-full flex justify-center">
                <Link to={route.newOrder}>
                  <button
                    type="button"
                    className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  >
                    કામ ઉમેરો
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>

      {order && order?.id && (
        <div ref={printRef} className="print:flex hidden">
          <OrderPdf order={order} />
        </div>
      )}
    </Layout>
  );
};
export default OrderDetailsPage;
